export const OfficeConsultationsListState = {
	url: '/consultations',
	title: 'Office Consultations List',
	template: '<consultation-page></consultation-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeConsultationsListPageMod" */
			'@Containers/office-consultation-page/office-consultation-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
